import {
  PieChart as RechartsPieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend
} from 'recharts'
import { cn } from '@/lib/utils'

export interface PieChartData {
  name: string
  value: number
  color?: string
}

interface PieChartProps {
  data: PieChartData[]
  colors?: string[]
  height?: number
  innerRadius?: number
  outerRadius?: number
  showLegend?: boolean
  className?: string
}

const DEFAULT_COLORS = [
  'hsl(var(--primary))',
  'hsl(215, 20%, 30%)',
  'hsl(215, 20%, 40%)',
  'hsl(215, 20%, 50%)',
  'hsl(215, 20%, 60%)',
  'hsl(25, 95%, 53%)',
  'hsl(25, 95%, 63%)',
  'hsl(25, 95%, 73%)',
]

export function PieChart({
  data,
  colors = DEFAULT_COLORS,
  height = 300,
  innerRadius = 0,
  outerRadius = 100,
  showLegend = true,
  className
}: PieChartProps) {
  // Apply colors to data if not already provided
  const dataWithColors = data.map((item, index) => ({
    ...item,
    color: item.color || colors[index % colors.length]
  }))

  return (
    <div className={cn("w-full", className)}>
      <ResponsiveContainer width="100%" height={height}>
        <RechartsPieChart>
          <Pie
            data={dataWithColors}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name}: ${((percent ?? 0) * 100).toFixed(0)}%`}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            paddingAngle={2}
            dataKey="value"
          >
            {dataWithColors.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.color}
              />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: 'hsl(var(--card))',
              border: '1px solid hsl(var(--border))',
              borderRadius: '0.5rem'
            }}
            itemStyle={{ color: 'hsl(var(--foreground))' }}
            labelStyle={{ color: 'hsl(var(--muted-foreground))' }}
          />
          {showLegend && (
            <Legend />
          )}
        </RechartsPieChart>
      </ResponsiveContainer>
    </div>
  )
}
